export var COUPON_STATUS;
(function (COUPON_STATUS) {
    COUPON_STATUS["CAN_RECEIVE"] = "CAN_RECEIVE";
    //可领取
    COUPON_STATUS["UNUSED"] = "UNUSED";
    // 待使用
    COUPON_STATUS["ALREADY_SEND"] = "ALREADY_SEND";
    // 已领取
    COUPON_STATUS["ALREADY_USE"] = "ALREADY_USE";
    //已使用
    COUPON_STATUS["NOT_START"] = "NOT_START";
    //未开始
    COUPON_STATUS["NO_STOCK"] = "NO_STOCK";
    //今日券已发完
    COUPON_STATUS["ALREADY_END"] = "ALREADY_END";
    //已结束
    //不展示的状态
    COUPON_STATUS["NOT_PASS_USER_RULE"] = "NOT_PASS_USER_RULE";
    //未过用户规则
    COUPON_STATUS["NOT_ONLINE"] = "NOT_ONLINE";
    //玩法不在线
    COUPON_STATUS["OVERDUE"] = "OVERDUE";
    //已过期
    COUPON_STATUS["RECEIVE_MUTEX_COUPON_LIMIT"] = "RECEIVE_MUTEX_COUPON_LIMIT"; //互斥领取限制
})(COUPON_STATUS || (COUPON_STATUS = {}));
export function getStatus(allStatus) {
    if (allStatus.indexOf('CAN_RECEIVE') !== -1) {
        return COUPON_STATUS.CAN_RECEIVE;
    }
    if (allStatus.indexOf('UNUSED') !== -1) {
        return COUPON_STATUS.UNUSED;
    }
    if (allStatus.indexOf('ALREADY_USE') !== -1) {
        return COUPON_STATUS.ALREADY_USE;
    }
    if (allStatus.indexOf('ALREADY_SEND') !== -1) {
        return COUPON_STATUS.ALREADY_SEND;
    }
    if (allStatus.indexOf('NOT_START') !== -1) {
        return COUPON_STATUS.NOT_START;
    }
    if (allStatus.indexOf('NO_STOCK') !== -1) {
        return COUPON_STATUS.NO_STOCK;
    }
    if (allStatus.indexOf('ALREADY_END') !== -1) {
        return COUPON_STATUS.ALREADY_END;
    }
    return COUPON_STATUS.ALREADY_END;
}
export function throttle(func, wait) {
    let timeout = null;
    return function () {
        let args = arguments;
        if (!timeout) {
            timeout = setTimeout(function () {
                timeout = null;
                func && func(args);
            }, wait);
        }
    };
}
